import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CartDrawer } from './components/CartDrawer';
import { Home } from './pages/Home';
import { Boutique } from './pages/Boutique';
import { Ferme } from './pages/Ferme';
import { Visites } from './pages/Visites';
import { Contact } from './pages/Contact';
export function App() {
  return <CartProvider data-id="element-0" data-mp="2mmcbg18ucy8l">
      <BrowserRouter data-id="element-1" data-mp="2mn5ccll4ctit">
        <div className="flex min-h-screen w-full flex-col bg-cream" data-id="element-2" data-mp="2mnng03a42a0r">
          <Header data-id="element-3" data-mp="31bs0ncsq4vm6" />
          <main className="flex-1" data-id="element-4" data-mp="31c9uk2rwyxqx">
            <Routes data-id="element-5" data-mp="2wk0b95lb0vxm">
              <Route path="/" element={<Home data-id="element-7" data-mp="2wj8dpp85co4p" />} data-id="element-6" data-mp="2wjgq7g0cxrfd" />
              <Route path="/boutique" element={<Boutique data-id="element-9" data-mp="28u5x8kp911bs" />} data-id="element-8" data-mp="2wip2ssgwz006" />
              <Route path="/la-ferme" element={<Ferme data-id="element-11" data-mp="28sl5f2ubjwhm" />} data-id="element-10" data-mp="28te1n9vnj3li" />
              <Route path="/visites" element={<Visites data-id="element-13" data-mp="23w4ey1znd61d" />} data-id="element-12" data-mp="23vchelmhoy8g" />
              <Route path="/contact" element={<Contact data-id="element-15" data-mp="23ti5txx3yih1" />} data-id="element-14" data-mp="23ut9zyugts8o" />
            </Routes>
          </main>
          <Footer data-id="element-16" data-mp="3ijfv1zlojwem" />
          <CartDrawer data-id="element-17" data-mp="3ihv0i9zd8dgr" />
        </div>
      </BrowserRouter>
    </CartProvider>;
}